import { useState } from "react";
import { CommonButton, CommonModal } from "../Input";

// Sub-components
import Step1CustomerSelection from "./CreateSingleTransaction/Step1CustomerSelection";
import Step2ReceiverList from "./CreateSingleTransaction/Step2ReceiverList";
import Step3PaymentInfo from "./CreateSingleTransaction/Step3PaymentInfo";
import Step4ConfirmTransaction from "./CreateSingleTransaction/Step4ConfirmTransaction";
import StepIndicator from "./CreateSingleTransaction/StepIndicator";
import Step5Success from "./SendBulkTransaction/Step5Success";

const CreateSingleTransactionModal = ({ show, onHide }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [selectedReceivers, setSelectedReceivers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [formData, setFormData] = useState({
    sendCurrency: "SGD",
  });

  const handleToggleReceiver = (item) => {
    if (selectedReceivers.includes(item.id)) {
      setSelectedReceivers(selectedReceivers.filter((id) => id !== item.id));
    } else {
      setSelectedReceivers([...selectedReceivers, item.id]);
    }
  };

  const handleNext = () => {
    if (currentStep < 5) setCurrentStep(currentStep + 1);
  };

  const handleBack = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1);
  };

  const resetAndHide = () => {
    setCurrentStep(1);
    setSelectedReceivers([]);
    setSelectedCustomer(null);
    onHide();
  };

  return (
    <CommonModal
      show={show}
      onHide={resetAndHide}
      fullscreen={true}
      backdrop="static"
      headerClassName="bg-light-gray-soft px-5 pt-4 pb-2 border-bottom-0"
      bodyClassName="bg-light-gray-soft px-5 pb-5 pt-0"
      footerClassName="bg-light-gray-soft pb-4 pt-0 ps-5 pe-5 border-top-0"
      title={
        currentStep <= 5 ? (
          <div className="w-100 pe-5">
            <StepIndicator currentStep={currentStep} />
          </div>
        ) : null
      }
      footer={
        currentStep < 5 ? (
          <div className="d-flex justify-content-end gap-3 w-100 mt-4">
            {currentStep === 2 && (
              <CommonButton variant="outline" className="px-5">
                Add
              </CommonButton>
            )}
            <CommonButton
              variant="outline"
              className="px-5 bg-white border"
              style={{
                borderColor: "#D0D5DD",
                color: "#344054",
                fontWeight: "600",
                borderRadius: "8px",
              }}
              onClick={currentStep === 1 ? resetAndHide : handleBack}
            >
              {currentStep === 1 ? "Back" : "Back"}
            </CommonButton>
            <CommonButton
              className="px-5 fw-bold"
              style={{
                borderRadius: "8px",
              }}
              onClick={handleNext}
            >
              Next
            </CommonButton>
          </div>
        ) : null
      }
    >
      <div
        className={
          currentStep === 5
            ? "flex-grow-1 d-flex align-items-center justify-content-center"
            : ""
        }
        style={{ minHeight: "550px" }}
      >
        {currentStep === 1 && (
          <Step1CustomerSelection
            selectedCustomer={selectedCustomer}
            onSelectCustomer={setSelectedCustomer}
          />
        )}
        {currentStep === 2 && (
          <Step2ReceiverList
            selectedReceivers={selectedReceivers}
            onToggleReceiver={handleToggleReceiver}
          />
        )}
        {currentStep === 3 && (
          <Step3PaymentInfo formData={formData} setFormData={setFormData} />
        )}
        {currentStep === 4 && (
          <Step4ConfirmTransaction
            selectedCustomer={selectedCustomer}
            selectedReceivers={selectedReceivers}
            formData={formData}
          />
        )}
        {currentStep === 5 && <Step5Success />}
      </div>
    </CommonModal>
  );
};

export default CreateSingleTransactionModal;
